module.exports = __webpack_public_path__ + "0b2c65c6fcee1d33d244dfe3abf9df81.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SK.svg
// module id = dGh9
// module chunks = 0